module.exports = __webpack_public_path__ + "img/joyskit-md.ba9154e4.png";